
import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import Alert from "@mui/material/Alert";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";

import loginBg from "./images/LOGIN-IMG.jpg";
import loginIcon from "./images/LOGIN-ICON-1.png";

import "./styles/styles.css";



import API_URL from "./Apiurl";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      us_phone: "",
      us_password: "",
      checked: true,
      showPassword: false,
      loginerropen: false,
      errormessage: "",
      errortype: "error",
      btnlogdisabled: false,
      btnLogintext: "Login",
      redirect: false,
      pagename: ""
    };
  }
componentWillMount() { 
if(localStorage.getItem("VRuserid")!==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Dashboard'
          })
		  }
}
  myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    if (nam === "us_phone") {
      val = val.replace(/\D/g, "");
      if (val.length > 10) return;
    }

    this.setState({ [nam]: val });
  };

  handleChange = () => {
    this.setState({ checked: !this.state.checked });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleErrorclose = () => {
    this.setState({ loginerropen: false });
  };

  validateForm = () => {
    const { us_phone, us_password } = this.state;
    const phoneRegex = /^[0-9]{10}$/;

    if (!us_phone) {
      this.setState({
        errormessage: "Please Enter Phone Number",
        loginerropen: true,
        errortype: "error"
      });
      return false;
    }

    if (!phoneRegex.test(us_phone)) {
      this.setState({
        errormessage: "Please Enter Valid 10 Digit Phone Number",
        loginerropen: true,
        errortype: "error"
      });
      return false;
    }

    if (!us_password) {
      this.setState({
        errormessage: "Please Enter Password",
        loginerropen: true,
        errortype: "error"
      });
      return false;
    }

    return true;
  };

  handleClickLogin = (event) => {
    event.preventDefault();

    if (!this.validateForm()) return;

    this.setState({
      btnlogdisabled: true,
      btnLogintext: "Processing...",
      loginerropen: false,
      errormessage: ""
    });

    const formData = new FormData();
    formData.append("action", "Login");
    formData.append("us_phone", this.state.us_phone);
    formData.append("us_password", this.state.us_password);

    axios.post(API_URL + "ajaxuser.php", formData)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          let msg = res.data[0].msg;

          if (msg === "1") {
            localStorage.setItem("VRuserid", res.data[0].us_id);
localStorage.setItem("VRName", res.data[0].us_name);
          

            this.setState({
              errormessage: "Login Successful",
              loginerropen: true,
              errortype: "success",
              btnlogdisabled: false,
              btnLogintext: "Login",
              redirect: true,
              pagename: "/Dashboard"
            });
          }else  if (msg === "2") {
 this.setState({
              errormessage: "Your account is blocked, please contact admin",
              loginerropen: true,
              errortype: "error",
              btnlogdisabled: false,
              btnLogintext: "Login",
              redirect: false,
             
            });

		  }			  else {
            this.setState({
              errormessage: "Invalid Password",
              loginerropen: true,
              errortype: "error",
              btnlogdisabled: false,
              btnLogintext: "Login"
            });
          }
        }
		else{
			this.setState({
              errormessage: "Invalid Credentials",
              loginerropen: true,
              errortype: "error",
              btnlogdisabled: false,
              btnLogintext: "Login"
            });
		}
      })
      .catch(() => {});
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
    <div className="loginMain" style={{ backgroundImage: `url(${loginBg})` }}>
  
  
  <div className="loginLogo">
    <img src={require("./images/LOGIN-PAGE-LOGO.png")} alt="Logo" />
  </div>

  <div className="loginContainer">
    <div className="loginContent">

      <h1 className="loginTitle">Login</h1>
      <p className="loginSubTitle">
        Welcome to <span className="brandHighlight">VR Builders</span>
        <span className="loginDescription">Your Entire Team on One Foundation</span>
      </p>

      <Collapse in={this.state.loginerropen}>
        <Alert
          severity={this.state.errortype}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={this.handleErrorclose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          className="loginAlert"
        >
          {this.state.errormessage}
        </Alert>
      </Collapse>

      <form onSubmit={this.handleClickLogin}>

        <FormControl fullWidth margin="normal">
          <OutlinedInput
            className="loginInput"
            name="us_phone"
            value={this.state.us_phone}
            onChange={this.myChangeHandler}
            placeholder="Phone Number"
            endAdornment={
              <InputAdornment position="end">
                <img src={loginIcon} alt="icon" className="loginInputIcon" />
              </InputAdornment>
            }
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <OutlinedInput
            className="loginInput"
            name="us_password"
            value={this.state.us_password}
            onChange={this.myChangeHandler}
            placeholder="Password"
            type={this.state.showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={this.handleClickShowPassword}>
                  {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>

        <Button
          fullWidth
          type="submit"
          variant="contained"
          disabled={this.state.btnlogdisabled}
          className="loginButton"
        >
          {this.state.btnLogintext}
        </Button>

      </form>
    </div>
  </div>
</div>


    );
  }
}